import PadelRoundLineupEditor from '@/components/community/padel/PadelRoundLineupEditor';
import PadelConfirmDialog from '@/components/community/padel/PadelConfirmDialog';
import PadelFeedbackDialog from '@/components/community/padel/PadelFeedbackDialog';
import type { MabarParticipant } from '@/services/communityService';
import type { PadelGameListItem } from '@/services/padelService';

interface FeedbackState {
  icon: string;
  title: string;
  message: string;
  variant?: 'success' | 'error';
}

interface PadelStatistikDialogsProps {
  participants: MabarParticipant[];
  isSparring: boolean;
  teamAName: string;
  teamBName: string;
  lineupGame: PadelGameListItem | null;
  pendingGameNumber: number | null;
  resetOpen: boolean;
  resetting: boolean;
  feedback?: FeedbackState | null;
  onCloseLineup: () => void;
  onCloseDelete: () => void;
  onCloseReset: () => void;
  onCloseFeedback?: () => void;
  onLineupSaved: () => void;
  onConfirmDelete: () => void;
  onConfirmReset: () => void;
  onError: (title: string, message: string) => void;
}

export default function PadelStatistikDialogs({
  participants,
  isSparring,
  teamAName,
  teamBName,
  lineupGame,
  pendingGameNumber,
  resetOpen,
  resetting,
  feedback,
  onCloseLineup,
  onCloseDelete,
  onCloseReset,
  onCloseFeedback,
  onLineupSaved,
  onConfirmDelete,
  onConfirmReset,
  onError,
}: PadelStatistikDialogsProps) {
  return (
    <>
      {lineupGame && (
        <PadelRoundLineupEditor
          isOpen
          onClose={onCloseLineup}
          game={lineupGame}
          participants={participants}
          isSparring={isSparring}
          teamAName={teamAName}
          teamBName={teamBName}
          onSuccess={onLineupSaved}
          onError={(message) => onError('Gagal menyimpan', message)}
        />
      )}
      <PadelConfirmDialog
        open={pendingGameNumber != null}
        title="Yakin hapus?"
        message={`Game ${pendingGameNumber ?? ''} akan dihapus dari rekap.`}
        onCancel={onCloseDelete}
        onConfirm={onConfirmDelete}
      />
      <PadelConfirmDialog
        open={resetOpen}
        title="Reset semua game?"
        message="Semua data game, skor, dan klasemen akan dihapus permanen."
        confirmLabel={resetting ? 'Memproses...' : 'Ya, Reset'}
        onCancel={onCloseReset}
        onConfirm={onConfirmReset}
      />
      {feedback && onCloseFeedback && (
        <PadelFeedbackDialog
          open={feedback != null}
          icon={feedback?.icon || 'mdi:check'}
          title={feedback?.title || ''}
          message={feedback?.message || ''}
          variant={feedback?.variant}
          onClose={onCloseFeedback}
        />
      )}
    </>
  );
}
